import { Injectable } from '@angular/core';
import { environment } from '~env/environment';
import { SCRIPT_TYPE } from '~shared/constants/sources.config';
import { TIME_DURATION } from '~shared/constants';

@Injectable({
  providedIn: 'root',
})
export class OptimizeExperimentService {

  private antiFlickerTimeOut = TIME_DURATION;

  public loadAntiFlickerScript() {
    const node = this.createScriptTag;
    node.innerText = `(function (a, s, y, n, c, h, i, d, e) {
           s.className += ' ' + y;
           h.start = 1 * new Date;

           h.end = i = function () {
               s.className = s.className.replace(RegExp(' ?' + y), '')
           };

           (a[n] = a[n] || []).hide = h;
           setTimeout(function () {
               i();
               h.end = null
           }, c);

           h.timeout = c;
       })(window, document.documentElement, 'async-hide', 'dataLayer',
       ${this.antiFlickerTimeOut},
       {'${[environment.gaTrackingId()]}': true});`;

    node.type = SCRIPT_TYPE;
    node.async = true;
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  private get createScriptTag() {
    return document.createElement('script');
  }
}
